<template>
    <div>
        <div class="modal fade" tabindex="-1" id="ModalProcessoCalendario" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content calendar-modal position-relative">
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 z-3"
                            data-bs-dismiss="modal"
                            aria-label="Fechar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-body p-0 calendar-modal-body">
                        <div class="calendar-header d-flex align-items-center justify-content-between p-3 border-bottom calendar-header-responsive">
                            <div class="d-flex align-items-center gap-2 today-button-container">
                                <button class="btn btn-outline-primary btn-today" @click="goToday">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="me-1">
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                                    </svg>
                                    Hoje
                                </button>
                            </div>

                            <div class="text-center flex-grow-1">
                                <button type="button"
                                        class="month-trigger-modern"
                                        @click="openMonthPicker"
                                        :aria-label="`Selecionar mês/ano (atual: ${monthLabel} ${currentYear})`">
                                    <span class="month-label">{{ monthLabel }}</span>
                                    <span class="year-label">{{ currentYear }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16" class="calendar-icon">
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
                                    </svg>
                                </button>
                                <input ref="monthPicker"
                                       type="month"
                                       :value="monthInput"
                                       @input="onMonthPicked"
                                       class="visually-hidden month-native-picker" />
                            </div>

                            <button type="button"
                                    class="filter-toggle-btn"
                                    @click="toggleFiltros"
                                    :class="{ 'active': mostrarFiltros }"
                                    :title="temFiltrosAtivos ? 'Filtros ativos' : 'Filtrar resultados'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z" />
                                </svg>
                                <span v-if="temFiltrosAtivos" class="filter-badge"></span>
                            </button>
                        </div>

                        <!-- Painel de Filtros -->
                        <transition name="slide-filters">
                            <div v-if="mostrarFiltros" class="filters-panel">
                                <div class="filters-grid">
                                    <!-- Legislação -->
                                    <div class="filter-item">
                                        <label class="filter-label">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="filter-icon">
                                                <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"/>
                                            </svg>
                                            Legislação
                                        </label>
                                        <div class="select-wrapper">
                                            <select v-model="filtroIdLegislacao" class="filter-input filter-select">
                                                <option value="">Todas as legislações</option>
                                                <option v-for="leg in legislacoes"
                                                        :key="leg.idLegislacao"
                                                        :value="String(leg.idLegislacao)">
                                                    {{ leg.dsNome }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <!-- Tipo de Processo -->
                                    <div class="filter-item">
                                        <label class="filter-label">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="filter-icon">
                                                <path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2z"/>
                                                <path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
                                            </svg>
                                            Tipo de Processo
                                        </label>
                                        <div class="select-wrapper">
                                            <select v-model="filtroIdTipoProcesso" class="filter-input filter-select">
                                                <option value="">Todos os tipos de processo</option>
                                                <option v-for="tp in tiposProcessos"
                                                        :key="tp.idTipoProcesso"
                                                        :value="String(tp.idTipoProcesso)">
                                                    {{ tp.nmTipoProcesso }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="filters-actions">
                                    <button type="button"
                                            class="filter-btn filter-btn-secondary"
                                            @click="limparFiltros">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                        </svg>
                                        Limpar
                                    </button>
                                    <button type="button"
                                            class="filter-btn filter-btn-primary"
                                            @click="aplicarFiltros">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                        </svg>
                                        Aplicar
                                    </button>
                                </div>
                            </div>
                        </transition>
                        <div class="calendar-scroll-wrapper">
                            <div class="weekdays px-3 pt-3 calendar-weekdays">
                                <div v-for="(w,i) in weekdays" :key="i" class="weekday">
                                    <span class="weekday-full">{{ w }}</span>
                                    <span class="weekday-short">{{ getShortWeekday(w) }}</span>
                                </div>
                            </div>

                            <div class="calendar-grid p-3 calendar-grid-container">
                                <div v-for="day in calendarDays"
                                     :key="day.dateKey"
                                     class="day-cell"
                                     :class="{ 'other-month': !day.inCurrentMonth, 'today': day.isToday, 'has-events': day.events && day.events.length }"
                                     @click="openDay(day)">
                                    <div class="day-number"><span>{{ day.day }}</span></div>

                                    <div class="events">
                                        <div v-for="(ev, idx) in limitedEvents(day.events)"
                                             :key="idx"
                                             class="event-pill"
                                             :title="ev.title"
                                             :class="pillStateClass(ev)"
                                             @click.stop="openDay(day)">
                                            {{ ev.title }}
                                        </div>

                                        <div v-if="day.events && day.events.length > maxEventsInline"
                                             class="more-pill"
                                             @click.stop="openDay(day)">
                                            +{{ day.events.length - maxEventsInline }} mais
                                        </div>

                                        <div v-if="showPlaceholders && (!day.events || day.events.length === 0)" class="event-placeholder" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!-- modal-content -->
            </div>
        </div>

        <div class="modal fade" tabindex="-1" id="ModalDayDetails" ref="modalDay" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content day-details-modal border-0 shadow-lg">
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 z-3"
                            data-bs-dismiss="modal"
                            aria-label="Fechar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-header day-details-header border-0 pb-3">
                        <div class="d-flex align-items-center gap-3">
                            <div class="calendar-icon-wrapper">
                                <i class="fa fa-calendar-day"></i>
                            </div>
                            <div>
                                <h5 class="modal-title mb-0 fw-bold">{{ selectedDateLabel }}</h5>
                                <p class="text-muted small mb-0 mt-1">
                                    {{ selectedEvents.length }} {{ selectedEvents.length === 1 ? 'item' : 'itens' }} com prazo
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="modal-body day-details-body pt-0">
                        <div v-if="selectedEvents.length === 0" class="empty-state text-center py-5">
                            <div class="empty-icon mb-3">
                                <i class="far fa-calendar-check"></i>
                            </div>
                            <h6 class="text-muted mb-2">Nenhum item com prazo</h6>
                            <p class="text-muted small mb-0">Não há artefatos agendados para este dia.</p>
                        </div>

                        <div v-else class="events-list">
                            <button v-for="(ev,index) in selectedEvents"
                                    :key="index"
                                    type="button"
                                    class="event-card mt-1"
                                    :class="pillStateClass(ev)"
                                    @click="openArtefato(ev)">
                                <div class="event-card-indicator"></div>
                                <div class="event-card-content">
                                    <div class="event-card-header d-flex align-items-start justify-content-between gap-3 mb-2">
                                        <div class="d-flex align-items-start gap-3 flex-grow-1 min-w-0">
                                            <div class="event-icon">
                                                <i class="far fa-file-alt"></i>
                                            </div>
                                            <div class="flex-grow-1 min-w-0">
                                                <h6 class="event-title mb-1" v-if="ev.tpRegistro == 'ProcessosArtefatosResponsavel'">
                                                    {{ ev.raw?.nmModelo }}
                                                </h6>
                                                <h6 class="event-title mb-1" v-else>
                                                    {{ ev.raw?.dsNome }}
                                                </h6>
                                                <div class="event-badge">
                                                    <i class="far fa-clock me-1"></i>
                                                    {{ ev.dueDate.toLocaleDateString('pt-BR') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="event-status-badge" v-if="pillStateClass(ev) === 'is-success'">
                                            <i class="fas fa-check-circle me-1"></i>
                                            {{ ev.flTemWorkflow ? 'Finalizado' : 'Enviado' }}
                                        </div>
                                        <div class="event-status-badge warning" v-else-if="pillStateClass(ev) === 'is-warning'">
                                            <i class="fas fa-exclamation-triangle me-1"></i>
                                            Próximo
                                        </div>
                                        <div class="event-status-badge danger" v-else-if="pillStateClass(ev) === 'is-danger'">
                                            <i class="fas fa-exclamation-circle me-1"></i>
                                            Atrasado
                                        </div>
                                    </div>

                                    <div class="event-card-body">
                                        <div class="event-info-row" v-if="ev.tpRegistro == 'ProcessosArtefatosResponsavel'">
                                            <i class="far fa-folder-open me-2"></i>
                                            <span class="event-info-label">Processo:</span>
                                            <span class="event-info-value">{{ ev.raw?.dsNome }}</span>
                                        </div>
                                        <div class="event-info-row" v-else>
                                            <i class="far fa-folder-open me-2"></i>
                                            <span class="event-info-label">Detalhes:</span>
                                            <span class="event-info-value">{{ ev.raw?.titulo }}</span>
                                        </div>
                                    </div>

                                    <div class="event-card-footer mt-2">
                                        <span class="view-link">
                                            Ver detalhes
                                            <i class="fas fa-arrow-right ms-1"></i>
                                        </span>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalProcessoArtefato ref="modalArtefato"
                               :showModal="artefatoShow"
                               :idProcesso="String(artefato.idProcesso)"
                               :idProcessoModeloArtefato="String(artefato.idProcessoModeloArtefato)"
                               :dsNome="artefato.dsNome"
                               :flPermissao="true"
                               :flProprietario="false"
                               :idLegislacao="artefato.idLegislacao"
                               :cdLegislacao="artefato.cdLegislacao"
                               @child-modal="onChildModalState"
                               @ver-documento="onVerDocumento" />
    </div>
</template>

<script>
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import ModalProcessoArtefato from '@/components/ModalProcessoArtefato.vue'

    export default {
        name: 'ModalProcessoCalendario',
        components: { ModalProcessoArtefato },
        props: {
            legislacoes: {
                type: Array,
                default: () => []
            },
            tiposProcessos: {
                type: Array,
                default: () => []
            }
        },
        data() {
            const now = new Date()
            return {
                modalInstance: null,
                dayModalInstance: null,

                currentYear: now.getFullYear(),
                currentMonth: now.getMonth(),
                eventsByDate: {},

                weekdays: ['DOMINGO', 'SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁBADO'],
                showPlaceholders: false,

                maxEventsInline: 2,

                selectedDay: null,
                selectedEvents: [],
                selectedDateLabel: '',

                openDayAfterHide: false,
                openArtefatoAfterHide: false,
                returnToCalendarAfterDay: true,
                artefatoChildOpen: false,
                artefatoSubDepth: 0,
                suppressDayReturn: false,
                artefatoShow: false,
                artefato: {
                    idProcesso: null,
                    idProcessoModeloArtefato: null,
                    dsNome: '',
                    idLegislacao: null,
                    cdLegislacao: null,
                },
                skipReturnOnArtefatoClose: false,
                filtroIdLegislacao: '',
                filtroIdTipoProcesso: '',
                mostrarFiltros: false,
            }
        },
        computed: {
            monthLabel() {
                const date = new Date(this.currentYear, this.currentMonth, 1)
                const m = date.toLocaleString('pt-BR', { month: 'long' })
                return m.charAt(0).toUpperCase() + m.slice(1)
            },
            monthInput: {
                get() {
                    const m = (this.currentMonth + 1).toString().padStart(2, '0')
                    return `${this.currentYear}-${m}`
                },
                set(v) {
                    if (!v) return
                    const [y, m] = v.split('-').map(n => parseInt(n, 10))
                    if (!Number.isNaN(y) && !Number.isNaN(m)) {
                        this.currentYear = y
                        this.currentMonth = m - 1
                    }
                }
            },

            calendarDays() {
                const year = this.currentYear
                const month = this.currentMonth

                const firstOfMonth = new Date(year, month, 1)
                const lastOfMonth = new Date(year, month + 1, 0)

                const firstDow = firstOfMonth.getDay()
                const dim = lastOfMonth.getDate()
                const weeks = Math.ceil((firstDow + dim) / 7)

                const start = new Date(year, month, 1 - firstDow)

                const totalCells = weeks * 7
                const cells = []
                for (let i = 0; i < totalCells; i++) {
                    const d = new Date(start)
                    d.setDate(start.getDate() + i)

                    const y = d.getFullYear()
                    const m = d.getMonth()
                    const day = d.getDate()

                    const dateKey = `${y}-${String(m + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`

                    const today = new Date(); today.setHours(0, 0, 0, 0)
                    const dz = new Date(y, m, day); dz.setHours(0, 0, 0, 0)

                    cells.push({
                        date: d,
                        dateKey,
                        day,
                        inCurrentMonth: m === month,
                        isToday: dz.getTime() === today.getTime(),
                        events: this.eventsByDate[dateKey] || []
                    })
                }
                return cells
            },

            temFiltrosAtivos() {
                return !!(this.filtroIdLegislacao || this.filtroIdTipoProcesso);
            }
        },

        methods: {
            abrir() {
                const now = new Date()
                this.currentYear = now.getFullYear()
                this.currentMonth = now.getMonth()
                this.getCalendario()
                this.modalInstance.show()
            },

            openMonthPicker() {
                const el = this.$refs.monthPicker
                if (!el) return
                try {
                    if (typeof el.showPicker === 'function') el.showPicker()
                    else { el.focus(); setTimeout(() => el.click(), 0) }
                } catch {
                    el.focus(); setTimeout(() => el.click(), 0)
                }
            },

            onMonthPicked(e) {
                const v = e.target.value
                if (!v) return
                const [y, m] = v.split('-').map(n => parseInt(n, 10))
                if (Number.isFinite(y) && Number.isFinite(m)) {
                    this.currentYear = y
                    this.currentMonth = m - 1
                    this.getCalendario()
                }
            },

            goToday() {
                const now = new Date()
                this.currentYear = now.getFullYear()
                this.currentMonth = now.getMonth()
                this.getCalendario()
            },

            buildVisibleRange(year, month) {
                const first = new Date(year, month, 1)
                const start = new Date(first)
                start.setDate(first.getDate() - first.getDay())
                start.setHours(0, 0, 0, 0)

                const last = new Date(year, month + 1, 0)
                const end = new Date(last)
                end.setDate(last.getDate() + (6 - last.getDay()))
                end.setHours(23, 59, 59, 999)

                return { dtInicio: start.toISOString(), dtFim: end.toISOString() }
            },

            dateKeyLocal(d) {
                const y = d.getFullYear()
                const m = String(d.getMonth() + 1).padStart(2, '0')
                const day = String(d.getDate()).padStart(2, '0')
                return `${y}-${m}-${day}`
            },

            toggleFiltros() {
                this.mostrarFiltros = !this.mostrarFiltros;
            },

            aplicarFiltros() {
                this.getCalendario();
            },

            limparFiltros() {
                this.filtroIdLegislacao = ''
                this.filtroIdTipoProcesso = ''
                this.getCalendario()
            },

            async getCalendario() {
                try {
                    const { dtInicio, dtFim } = this.buildVisibleRange(this.currentYear, this.currentMonth)
                    const params = {
                        dtInicio,
                        dtFim,
                        idLegislacao: this.filtroIdLegislacao || null,
                        idTipoProcesso: this.filtroIdTipoProcesso || null,
                    }

                    const { data } = await axios.get(
                        `${urlApi}/ProcessoArtefatoResponsavel/GetCalendario`,
                        { showLoading: true, params }
                    )

                    const rows = data.data.rows
                    const map = {}
                    for (const row of rows) {
                        const r = row.processoArtefatoResponsavel || row
                        if (!r?.dtLimite) continue

                        const lim = new Date(r.dtLimite)
                        const key = this.dateKeyLocal(lim)

                        if (!map[key]) map[key] = []

                        let titulo = r.titulo;
                        if (r.tpRegistro == 'ProcessosArtefatosResponsavel')
                            titulo = `${r.nmModelo} referente ao Processo: ${r.dsNome} •  ${lim.toLocaleDateString('pt-BR')}`;

                        map[key].push({
                            id: r.idProcessoArtefatoResponsavel,
                            title: titulo,
                            raw: r,
                            dueDate: lim,
                            flEnviado: Number(r.qtdEnviado || 0) > 0,
                            flTemWorkflow: !!r.flTemWorkflow,
                            statusNm: r.nmTipoStatusHistorico || null,
                            tpRegistro: r.tpRegistro
                        })
                    }
                    this.eventsByDate = map
                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro desconhecido')
                    this.eventsByDate = {}
                }
            },

            onChildModalState(isOpen) {
                this.artefatoChildOpen = !!isOpen;
                if (isOpen) { this.artefatoSubDepth++; this.suppressDayReturn = true; }
                else {
                    this.artefatoSubDepth = Math.max(0, this.artefatoSubDepth - 1);
                    if (this.artefatoSubDepth === 0) this.suppressDayReturn = false;
                }
                const artEl = document.getElementById('ModalProcessoArtefato');
                if (artEl) {
                    if (isOpen) artEl.setAttribute('data-bs-focus', 'false');
                    else artEl.removeAttribute('data-bs-focus');
                }
            },

            pillStateClass(ev) {
                if (!ev) return ''
                if (ev.tpRegistro != 'ProcessosArtefatosResponsavel') return 'is-info'
                const today = new Date(); today.setHours(0, 0, 0, 0)
                const due = new Date(ev.dueDate); due.setHours(0, 0, 0, 0)
                const in7 = new Date(today); in7.setDate(in7.getDate() + 7)

                if (ev.flTemWorkflow) {
                    const status = (ev.statusNm || '').toLowerCase()
                    if (status === 'finalizado') return 'is-success'
                    if (due < today) return 'is-danger'
                    if (due <= in7) return 'is-warning'
                    return ''
                }

                if (ev.flEnviado) return 'is-success'
                if (due < today) return 'is-danger'
                if (due <= in7) return 'is-warning'
                return ''
            },


            limitedEvents(evts = []) {
                return evts.slice(0, this.maxEventsInline)
            },

            openDay(day) {
                this.selectedDay = day
                this.selectedEvents = day.events || []
                this.selectedDateLabel = day.date.toLocaleDateString('pt-BR', {
                    weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'
                })
                this.returnToCalendarAfterDay = true

                this.openDayAfterHide = true
                this.modalInstance?.hide()
            },

            openArtefato(ev) {
                const r = ev.raw || {}
                this.artefato = {
                    idProcesso: r.idProcesso,
                    idProcessoModeloArtefato: r.idProcessoModeloArtefato,
                    dsNome: r.dsNome || '',
                    idLegislacao: r.idLegislacao ?? null,
                    cdLegislacao: r.cdLegislacao ?? null,
                }

                this.returnToCalendarAfterDay = false
                this.openArtefatoAfterHide = true;

                if (ev.tpRegistro == 'ProcessosArtefatosResponsavel') {
                    if (document.getElementById('ModalDayDetails')?.classList.contains('show')) {
                        this.dayModalInstance?.hide();
                    } else {
                        this.artefatoShow = true;
                    }
                } else {
                    this.dayModalInstance?.hide();
                    this.$router.push({ name: 'DetalhesProcesso', params: { id: r.idProcesso } });
                }

                
            },
            onVerDocumento() {
                this.skipReturnOnArtefatoClose = true;
                this.returnToCalendarAfterDay = false;
                this.openDayAfterHide = false;
                this.openArtefatoAfterHide = false;
            },

            getShortWeekday(fullName) {
                const shortMap = {
                    'DOMINGO': 'DOM',
                    'SEGUNDA': 'SEG',
                    'TERÇA': 'TER',
                    'QUARTA': 'QUA',
                    'QUINTA': 'QUI',
                    'SEXTA': 'SEX',
                    'SÁBADO': 'SÁB'
                };
                return shortMap[fullName] || fullName.substr(0, 3);
            },
        },

        mounted() {
            this.modalInstance = new window.bootstrap.Modal('#ModalProcessoCalendario', { focus: false });
            this.dayModalInstance = new window.bootstrap.Modal('#ModalDayDetails', { focus: false });

            const calEl = document.getElementById('ModalProcessoCalendario');
            calEl?.addEventListener('hidden.bs.modal', () => {
                if (this.openDayAfterHide) {
                    this.openDayAfterHide = false;
                    this.dayModalInstance?.show();
                }
            });

            const dayEl = document.getElementById('ModalDayDetails');
            dayEl?.addEventListener('hidden.bs.modal', () => {
                if (this.openArtefatoAfterHide) {
                    this.openArtefatoAfterHide = false;
                    this.artefatoShow = true;
                } else if (this.returnToCalendarAfterDay && !document.querySelector('.modal.show')) {
                    this.modalInstance?.show();
                }
            });

            this._onAnyShow = (ev) => {
                const artEl = document.getElementById('ModalProcessoArtefato');
                if (artEl && ev.target !== artEl && artEl.contains(ev.target)) {
                    this.artefatoSubDepth++;
                    this.suppressDayReturn = true;
                }
            };
            this._onAnyHidden = (ev) => {
                const artEl = document.getElementById('ModalProcessoArtefato');
                if (artEl && ev.target !== artEl && artEl.contains(ev.target)) {
                    this.artefatoSubDepth = Math.max(0, this.artefatoSubDepth - 1);
                    if (this.artefatoSubDepth === 0) this.suppressDayReturn = false;
                }
            };
            document.addEventListener('show.bs.modal', this._onAnyShow, true);
            document.addEventListener('hidden.bs.modal', this._onAnyHidden, true);

            this.$nextTick(() => {
                const artEl = document.getElementById('ModalProcessoArtefato');
                if (!artEl) return;

                const otherModalVisible = () => {
                    const open = Array.from(document.querySelectorAll('.modal.show'));
                    return open.some(el => !['ModalProcessoCalendario', 'ModalDayDetails', 'ModalProcessoArtefato'].includes(el.id));
                };

                artEl.addEventListener('hide.bs.modal', () => {
                    this.artefatoShow = false;
                    this.suppressDayReturn = true;
                });

                artEl.addEventListener('shown.bs.modal', () => {
                    this.suppressDayReturn = false;
                });

                artEl.addEventListener('hidden.bs.modal', () => {
                    setTimeout(() => {
                        if (this.skipReturnOnArtefatoClose) {
                            this.skipReturnOnArtefatoClose = false;
                            return;
                        }
                        // ainda tem um sub-modal aberto não reabre o Dia
                        if (otherModalVisible() || this.artefatoChildOpen || this.artefatoSubDepth > 0) return;

                        this.returnToCalendarAfterDay = true;
                        this.suppressDayReturn = false;
                        this.dayModalInstance?.show();
                    }, 150);
                });
            });

        },

        watch: {
        },

        beforeUnmount() {
            document.removeEventListener('show.bs.modal', this._onAnyShow, true);
            document.removeEventListener('hidden.bs.modal', this._onAnyHidden, true);
        },

        
    }
</script>

<style lang="scss" scoped>
    .calendar-modal {
        background: #fff;
        border: 0;
        border-radius: .75rem;
        padding: 0;
        max-height: 96vh;
        display: flex;
        flex-direction: column;
        position: relative;

        .btn-md {
            @media (max-width: 768px) {
                width: 40px;
                height: 40px;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            @media (max-width: 576px) {
                width: 36px;
                height: 36px;

                svg {
                    width: 14px;
                    height: 14px;
                }
            }
        }
    }

    

    .calendar-modal-body {
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
        display: flex;
        flex-direction: column;

        /* Scrollbar personalizada */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;

            &:hover {
                background: #94a3b8;
            }
        }
    }
    .calendar-header {
        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        position: relative;
    }

    .btn-today {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 10px 18px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 2px solid #e5e7eb;
        color: #2563eb;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 6px rgba(37, 99, 235, 0.1);
    }

        .btn-today:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            border-color: #2563eb;
            color: white;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
        }

        .btn-today svg {
            flex-shrink: 0;
        }

    @media (max-width: 768px) {
        .calendar-header {
            padding: .75rem !important;
            flex-wrap: wrap;
        }

        .btn-today {
            font-size: .875rem;
            padding: .5rem .875rem;
        }
    }

    @media (max-width: 576px) {
        .calendar-header {
            padding: .5rem !important;
        }

        .btn-today {
            font-size: .8rem;
            padding: .4rem .75rem;
        }
    }

    @media (max-width: 480px) {
        .calendar-header {
            padding: .4rem !important;
        }

        .btn-today {
            font-size: .75rem;
            padding: .35rem .65rem;
        }

        .btn-today svg {
            width: 14px;
            height: 14px;
        }
    }

    .month-trigger-modern {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 12px 24px;
        border-radius: 12px;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
        position: relative;
        overflow: hidden;
    }

        .month-trigger-modern::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            transform: translate(-50%, -50%) scale(0);
            transition: transform 0.6s ease;
            pointer-events: none;
        }

        .month-trigger-modern:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .month-trigger-modern:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(37, 99, 235, 0.35);
        }

        .month-trigger-modern:active {
            transform: translateY(0);
        }

    .month-label {
        font-size: 1.25rem;
        font-weight: 700;
        text-transform: uppercase;
        color: white;
        letter-spacing: 0.5px;
    }

    .year-label {
        font-size: 1.25rem;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.9);
    }

    .calendar-icon {
        color: white;
        opacity: 0.9;
        flex-shrink: 0;
    }

    @media (max-width: 768px) {
        .month-trigger-modern {
            padding: 10px 20px;
            gap: 8px;
        }

        .month-label, .year-label {
            font-size: 1.1rem;
        }

        .calendar-icon {
            width: 16px;
            height: 16px;
        }
    }

    @media (max-width: 576px) {
        .month-trigger-modern {
            padding: 8px 16px;
            gap: 6px;
        }

        .month-label, .year-label {
            font-size: 1rem;
        }

        .calendar-icon {
            width: 15px;
            height: 15px;
        }
    }

    @media (max-width: 480px) {
        .month-trigger-modern {
            padding: 7px 14px;
            gap: 5px;
        }

        .month-label, .year-label {
            font-size: .9rem;
        }

        .calendar-icon {
            width: 14px;
            height: 14px;
        }
    }

    .weekdays {
        display: grid;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        gap: .5rem;
        min-height: 2.5rem;

        .weekday {
            font-weight: 700;
            color: #5f6b7d;
            text-transform: uppercase;
            font-size: .8rem;
            text-align: center;
        }

        .weekday-short {
            display: none;
        }

        .weekday-full {
            display: inline;
        }
    }

    @media (max-width: 768px) {
        .weekdays {
            gap: .75rem;
            overflow-x: visible;
            overflow-y: visible;
            grid-template-columns: repeat(7, minmax(calc(50% - 0.375rem), 1fr));
            min-height: 3rem;

            .weekday {
                font-size: .85rem;
                letter-spacing: -0.3px;
                min-width: calc(50% - 0.375rem);
                flex-shrink: 0;
            }
        }
    }

    @media (max-width: 576px) {
        .weekdays {
            gap: .75rem;
            grid-template-columns: repeat(7, minmax(calc(50% - 0.375rem), 1fr));
            overflow-x: visible;
            overflow-y: visible;
            min-height: 3.25rem;

            .weekday {
                font-size: .9rem;
                min-width: calc(50% - 0.375rem);
                flex-shrink: 0;
            }

            .weekday-short {
                display: inline;
            }

            .weekday-full {
                display: none;
            }
        }
    }

    @media (max-width: 480px) {
        .weekdays {
            gap: .75rem;
            grid-template-columns: repeat(7, minmax(calc(50% - 0.375rem), 1fr));
            overflow-x: visible;
            overflow-y: visible;
            min-height: 3.5rem;

            .weekday {
                font-size: .9rem;
                letter-spacing: -0.3px;
                min-width: calc(50% - 0.375rem);
                flex-shrink: 0;
            }

        }

    }

    .calendar-scroll-wrapper {
        width: 100%;

        @media (max-width: 768px) {
            overflow-x: auto;
            overflow-y: visible;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: thin;
            scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
            display: block;
        }

        @media (max-width: 768px) {
            &::-webkit-scrollbar {
                height: 6px;
            }

            &::-webkit-scrollbar-track {
                background: transparent;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(0, 0, 0, 0.2);
                border-radius: 3px;
            }
        }

        @media (max-width: 576px) {
            overflow-x: auto;
            overflow-y: visible;
            -webkit-overflow-scrolling: touch;
        }

        @media (max-width: 480px) {
            overflow-x: auto;
            overflow-y: visible;
            -webkit-overflow-scrolling: touch;
        }
    }

    .calendar-weekdays {
        @media (max-width: 768px) {
            padding: .75rem 1rem 0 1rem !important;
            overflow-x: visible !important;
            overflow-y: visible !important;
            width: max-content;
            min-width: 100%;
        }

        @media (max-width: 576px) {
            padding: .5rem 1rem 0 1rem !important;
            width: max-content;
            min-width: 100%;
        }

        @media (max-width: 480px) {
            padding: .4rem 1rem 0 1rem !important;
            width: max-content;
            min-width: 100%;
        }
    }

    .calendar-grid-container {
        @media (max-width: 768px) {
            padding: 0 1rem 1rem 1rem !important;
            overflow-x: visible !important;
            overflow-y: visible !important;
            width: max-content;
            min-width: 100%;
        }

        @media (max-width: 576px) {
            padding: 0 1rem 1rem 1rem !important;
            width: max-content;
            min-width: 100%;
        }

        @media (max-width: 480px) {
            padding: 0 1rem 1rem 1rem !important;
            width: max-content;
            min-width: 100%;
        }
    }

    .calendar-grid {
        --cell-h: 130px;
        display: grid;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        grid-auto-rows: var(--cell-h);
        gap: .5rem;
        flex-shrink: 0;
    }

    @media (max-width: 1400px) {
        .calendar-grid {
            --cell-h: 140px;
        }
    }

    @media (max-width: 1200px) {
        .calendar-grid {
            --cell-h: 130px;
        }
    }

    @media (max-width: 992px) {
        .calendar-grid {
            --cell-h: 120px;
        }
    }

    @media (max-width: 768px) {
        .calendar-grid {
            --cell-h: 180px;
            gap: .75rem;
            grid-template-columns: repeat(7, minmax(calc(50% - 0.375rem), 1fr));
            overflow-x: visible;
            overflow-y: visible;
        }

        .day-cell {
            min-width: calc(50% - 0.375rem);
            flex-shrink: 0;
        }
    }

    @media (max-width: 576px) {
        .calendar-grid {
            --cell-h: 200px;
            gap: .75rem;
            grid-template-columns: repeat(7, minmax(calc(50% - 0.375rem), 1fr));
        }

        .day-cell {
            min-width: calc(50% - 0.375rem);
        }
    }

    @media (max-width: 480px) {
        .calendar-grid {
            --cell-h: 220px;
            gap: .75rem;
        }
    }

    .day-cell {
        position: relative;
        min-width: 0;
        height: 100%;
        border: 1px solid #e7e9ec;
        border-radius: .75rem;
        background: #fff;
        padding: .5rem;
        transition: box-shadow .15s ease;
        display: flex;
        flex-direction: column;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
    }

    .day-cell:hover {
        box-shadow: 0 8px 20px rgba(16,24,40,.06);
        cursor: pointer;
    }

    .day-cell:active {
        transform: scale(0.98);
        transition: transform 0.1s ease;
    }

    .day-cell.other-month {
        background: #f7f8fa;
        color: #9aa3af;
    }

    .day-cell.today {
        outline: 2px solid #0d6efd33;
        box-shadow: inset 0 0 0 2px #0d6efd33;
    }

    .day-number {
        position: absolute;
        top: .4rem;
        left: .5rem;
        font-weight: 700;
        font-size: .95rem;
        color: #344054;
    }

    @media (max-width: 768px) {
        .day-cell {
            padding: .75rem;
            border-radius: .75rem;
        }

        .day-number {
            font-size: 1.1rem;
            top: .5rem;
            left: .75rem;
        }
    }

    @media (max-width: 576px) {
        .day-cell {
            padding: .875rem;
            border-radius: .75rem;
        }

        .day-number {
            font-size: 1.2rem;
            top: .6rem;
            left: .875rem;
        }
    }

    @media (max-width: 480px) {
        .day-cell {
            padding: 1rem;
        }

        .day-number {
            font-size: 1.3rem;
            top: .75rem;
            left: 1rem;
        }

        .day-number span {
            display: inline-block;
        }
    }

    .events {
        margin-top: 1.6rem;
        display: flex;
        flex-direction: column;
        gap: .35rem;
        overflow: hidden;
    }

    .event-pill {
        font-size: .78rem;
        border-radius: .65rem;
        padding: .25rem .5rem;
        background: #eef4ff;
        color: #1d4ed8;
        border: 1px solid #dbe7ff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 768px) {
        .events {
            margin-top: 2rem;
            gap: .5rem;
        }

        .event-pill {
            font-size: .85rem;
            padding: .4rem .6rem;
            border-radius: .6rem;
        }
    }

    @media (max-width: 576px) {
        .events {
            margin-top: 2.2rem;
            gap: .6rem;
        }

        .event-pill {
            font-size: .9rem;
            padding: .45rem .7rem;
            border-radius: .65rem;
            border-width: 1px;
        }
    }

    @media (max-width: 480px) {
        .events {
            margin-top: 1rem;
            gap: .15rem;
        }

        .event-pill {
            font-size: .6rem;
            padding: .1rem .25rem;
            border-radius: .3rem;
        }
    }

    .day-cell.other-month .event-pill {
        background: #f0f0f0;
        border-color: #e5e7eb;
        color: #6b7280;
    }

    .event-pill.is-danger {
        background: #fde7e9;
        color: #842029;
        border-color: #f5c2c7;
    }

    .event-pill.is-warning {
        background: #fff3cd;
        color: #664d03;
        border-color: #ffecb5;
    }

    .event-pill.is-success {
        background: #d1e7dd;
        color: #0f5132;
        border-color: #badbcc;
    }

    .event-pill.is-info {
        background: #dbeafe;
        color: #2563eb;
        border-color: #bfdbfe;
    }

    .event-placeholder {
        height: 22px;
        border-radius: .5rem;
        background: linear-gradient(90deg, #f5f7fb 0%, #eef2f7 50%, #f5f7fb 100%);

        @media (max-width: 768px) {
            height: 18px;
        }

        @media (max-width: 576px) {
            height: 15px;
        }

        @media (max-width: 480px) {
            height: 12px;
        }
    }

    .more-pill {
        font-size: .78rem;
        border-radius: .65rem;
        padding: .2rem .5rem;
        background: #f3f4f6;
        color: #374151;
        border: 1px dashed #e5e7eb;
        width: max-content;
    }

    @media (max-width: 768px) {
        .more-pill {
            font-size: .85rem;
            padding: .3rem .5rem;
            border-radius: .6rem;
        }
    }

    @media (max-width: 576px) {
        .more-pill {
            font-size: .9rem;
            padding: .35rem .6rem;
            border-radius: .65rem;
        }
    }

    @media (max-width: 480px) {
        .more-pill {
            font-size: .95rem;
            padding: .4rem .65rem;
            border-radius: .7rem;
        }
    }

    .visually-hidden {
        position: absolute !important;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0,0,0,0);
        white-space: nowrap;
        border: 0;
    }

    /* Botão de Filtro no Header */
    .filter-toggle-btn {
        position: relative;
        width: 44px;
        height: 44px;
        border-radius: 10px;
        border: 2px solid #e5e7eb;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        color: #64748b;
        flex-shrink: 0;
    }

        .filter-toggle-btn:hover {
            border-color: #2563eb;
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
        }

        .filter-toggle-btn.active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            border-color: #2563eb;
            color: white;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
        }

            .filter-toggle-btn.active:hover {
                background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            }

    .filter-badge {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ef4444;
        border: 2px solid white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
        .filter-toggle-btn {
            width: 40px;
            height: 40px;
            margin-right: 3rem !important;
        }
    }

    @media (max-width: 576px) {
        .filter-toggle-btn {
            width: 36px;
            height: 36px;
            margin-right: 2.5rem !important;
        }

            .filter-toggle-btn svg {
                width: 18px;
                height: 18px;
            }
    }

    @media (max-width: 480px) {
        .filter-toggle-btn {
            margin-right: 2rem !important;
        }
    }

    /* Animação do Painel de Filtros */
    .slide-filters-enter-active,
    .slide-filters-leave-active {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        max-height: 500px;
        opacity: 1;
    }

    .slide-filters-enter-from,
    .slide-filters-leave-to {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
    }

    /* Painel de Filtros */
    .filters-panel {
        background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 2px solid #e5e7eb;
        padding: 24px;
        box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .filters-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 20px;
        margin-bottom: 20px;
    }

    .filter-item {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .filter-label {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #475569;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .filter-icon {
        color: #64748b;
        flex-shrink: 0;
    }

    .filter-input {
        width: 100%;
        padding: 12px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        color: #1f2937;
        background: #ffffff;
        transition: all 0.2s ease;
        font-family: inherit;
    }

        .filter-input:focus {
            outline: none;
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
            background: #ffffff;
        }

        .filter-input::placeholder {
            color: #94a3b8;
        }

    .select-wrapper {
        position: relative;
    }

        .select-wrapper::after {
            content: '';
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            width: 14px;
            height: 9px;
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-size: contain;
            pointer-events: none;
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            z-index: 1;
        }

        .select-wrapper:focus-within::after {
            transform: translateY(-50%) rotate(180deg);
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%232563eb' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        }

    .filter-select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        padding-right: 44px;
        cursor: pointer;
        width: 100%;
    }

    .filters-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding-top: 20px;
        border-top: 1px solid #e5e7eb;
    }

    .filter-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 12px 24px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

        .filter-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .filter-btn:active {
            transform: translateY(0);
        }

    .filter-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .filter-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
        }

    .filter-btn-secondary {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        color: #475569;
        border: 2px solid #e5e7eb;
    }

        .filter-btn-secondary:hover {
            background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
            border-color: #cbd5e1;
        }

    @media (max-width: 768px) {
        .filters-panel {
            padding: 20px 16px;
        }

        .filters-grid {
            grid-template-columns: 1fr;
            gap: 16px;
        }

        .filters-actions {
            flex-direction: column-reverse;
        }

        .filter-btn {
            width: 100%;
            justify-content: center;
        }
    }

    @media (max-width: 576px) {
        .filters-panel {
            padding: 16px 12px;
        }
    }

    .modal-xl {
        width: 90%;
        max-width: 1100px;
        margin: 2rem auto;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .modal-content {
            width: 100%;
            border-radius: 20px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
        }

        @media (max-width: 1200px) {
            max-width: 900px;
            margin: 1.5rem auto;
        }

        @media (max-width: 992px) {
            max-width: 700px;
            margin: 1rem auto;
        }

        @media (max-width: 768px) {
            width: 98%;
            max-width: none;
            margin: 0.75rem auto;

            .modal-content {
                border-radius: 12px;
            }
        }

        @media (max-width: 576px) {
            width: calc(100% - 1rem);
            margin: 0.5rem auto;

            .modal-content {
                border-radius: 8px;
            }
        }
    }

    /* Estilos da ModalDayDetails */
    .day-details-modal {
        border-radius: 1.25rem !important;
        
    }

    .day-details-header {
        background: linear-gradient(135deg, #235FE8 0%, #00d084 100%);
        padding: 1.75rem 2rem;
        color: white;

        .calendar-icon-wrapper {
            width: 56px;
            height: 56px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            backdrop-filter: blur(10px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .modal-title {
            color: white;
            font-size: 1.25rem;
            text-transform: capitalize;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }

        p {
            color: rgba(255, 255, 255, 0.9);
        }
    }

    .day-details-body {
        padding: 1.5rem 2rem 2rem;
        background: #f8f9fa;
        max-height: 70vh;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #e9ecef;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background: #adb5bd;
            border-radius: 10px;

            &:hover {
                background: #6c757d;
            }
        }
    }

    .empty-state {
        .empty-icon {
            font-size: 4rem;
            color: #dee2e6;

            i {
                animation: pulse 2s ease-in-out infinite;
            }
        }

        @keyframes pulse {
            0%, 100% { opacity: 0.4; }
            50% { opacity: 0.8; }
        }

        @media (max-width: 768px) {
            padding: 3rem 1rem !important;

            .empty-icon {
                font-size: 3rem;
            }

            h6 {
                font-size: 1rem;
            }

            p {
                font-size: .875rem;
            }
        }

        @media (max-width: 576px) {
            padding: 2.5rem 1rem !important;

            .empty-icon {
                font-size: 2.5rem;
            }

            h6 {
                font-size: .95rem;
            }

            p {
                font-size: .8rem;
            }
        }
    }

    .events-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        @media (max-width: 768px) {
            gap: .875rem;
        }

        @media (max-width: 576px) {
            gap: .75rem;
        }
    }

    .event-card {
        position: relative;
        display: block;
        width: 100%;
        background: white;
        border: none;
        border-radius: 1rem;
        padding: 0;
        text-align: left;
        overflow: hidden;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

            .view-link {
                color: #667eea;
                transform: translateX(4px);
            }

            .event-card-indicator {
                width: 6px;
            }
        }

        &:active {
            transform: translateY(0);
        }

        @media (max-width: 768px) {
            &:hover {
                transform: none;
            }

            &:active {
                transform: scale(0.98);
            }
        }
    }

    .event-card-indicator {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: #0d6efd;
        transition: width 0.3s ease;
    }

    .event-card.is-success .event-card-indicator {
        background: linear-gradient(180deg, #10b981 0%, #059669 100%);
    }

    .event-card.is-warning .event-card-indicator {
        background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
    }

    .event-card.is-danger .event-card-indicator {
        background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
    }

    .event-card-content {
        padding: 1.25rem 1.5rem 1.25rem 1.75rem;
    }

    .event-icon {
        width: 40px;
        height: 40px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 1.1rem;
        flex-shrink: 0;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    .event-card.is-success .event-icon {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }

    .event-card.is-warning .event-icon {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
    }

    .event-card.is-danger .event-icon {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
    }

    .event-card.is-info .event-icon {
        background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }

    .event-title {
        font-size: 1rem;
        font-weight: 600;
        color: #1f2937;
        margin: 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
    }

    .event-badge {
        display: inline-flex;
        align-items: center;
        font-size: 0.8rem;
        color: #6b7280;
        background: #f3f4f6;
        padding: 0.25rem 0.65rem;
        border-radius: 0.5rem;
        font-weight: 500;
    }

    .event-status-badge {
        display: inline-flex;
        align-items: center;
        font-size: 0.75rem;
        font-weight: 600;
        padding: 0.4rem 0.75rem;
        border-radius: 0.5rem;
        background: #d1e7dd;
        color: #0f5132;
        white-space: nowrap;
        flex-shrink: 0;

        i {
            font-size: 0.85rem;
        }

        &.warning {
            background: #fff3cd;
            color: #856404;
        }

        &.danger {
            background: #f8d7da;
            color: #842029;
        }
    }

    .event-card-body {
        margin-top: 0.75rem;
    }

    .event-info-row {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
        font-size: 0.9rem;
        color: #4b5563;
        line-height: 1.5;

        i {
            color: #9ca3af;
            margin-top: 0.15rem;
            flex-shrink: 0;
        }
    }

    .event-info-label {
        font-weight: 600;
        color: #6b7280;
        flex-shrink: 0;
    }

    .event-info-value {
        color: #374151;
        word-break: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
    }

    .event-card-footer {
        padding-top: 0.75rem;
        border-top: 1px solid #f3f4f6;
    }

    .view-link {
        font-size: 0.875rem;
        font-weight: 600;
        color: #6b7280;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;

        i {
            font-size: 0.75rem;
            transition: transform 0.3s ease;
        }
    }

    @media (max-width: 768px) {
        .day-details-modal {
            margin: 8px;
        }

        .day-details-header {
            padding: 1.5rem 1.25rem;

            .calendar-icon-wrapper {
                width: 48px;
                height: 48px;
                font-size: 1.25rem;
            }

            .modal-title {
                font-size: 1.1rem;
            }
        }

        .day-details-body {
            padding: 1.25rem;
            max-height: 60vh;
        }

        .event-card-content {
            padding: 1rem 1.25rem 1rem 1.5rem;
        }

        .event-card-header {
            flex-direction: column;
            align-items: flex-start !important;
        }

        .event-status-badge {
            align-self: flex-start;
            margin-top: .5rem;
        }
    }

    @media (max-width: 576px) {
        .day-details-modal {
            margin: 4px;
        }

        .day-details-header {
            padding: 1.25rem 1rem;

            .calendar-icon-wrapper {
                width: 44px;
                height: 44px;
                font-size: 1.1rem;
            }

            .modal-title {
                font-size: 1rem;
            }

            p {
                font-size: .85rem;
            }
        }

        .day-details-body {
            padding: 1rem;
            max-height: 55vh;
        }

        .event-card {
            border-radius: .75rem;
        }

        .event-card-content {
            padding: .875rem 1rem .875rem 1.25rem;
        }

        .event-icon {
            width: 36px;
            height: 36px;
            font-size: 1rem;
        }

        .event-title {
            font-size: .9rem;
        }

        .event-badge {
            font-size: .75rem;
            padding: .2rem .5rem;
        }

        .event-status-badge {
            font-size: .7rem;
            padding: .3rem .6rem;
        }

        .event-info-row {
            font-size: .85rem;
        }
    }

    @media (max-width: 480px) {
        .day-details-header {
            padding: 1rem .875rem;

            .calendar-icon-wrapper {
                width: 40px;
                height: 40px;
                font-size: 1rem;
            }

            .modal-title {
                font-size: .95rem;
            }

            p {
                font-size: .8rem;
            }
        }

        .day-details-body {
            padding: .875rem;
            max-height: 50vh;
        }

        .event-card-content {
            padding: .75rem .875rem .75rem 1rem;
        }

        .event-icon {
            width: 32px;
            height: 32px;
            font-size: .9rem;
        }

        .event-title {
            font-size: .85rem;
        }

        .event-badge {
            font-size: .7rem;
            padding: .15rem .4rem;
        }

        .event-status-badge {
            font-size: .65rem;
            padding: .25rem .5rem;
        }

        .event-info-row {
            font-size: .8rem;
        }

        .view-link {
            font-size: .8rem;
        }
    }

    /* ============================================
       DARK THEME - Modern & Beautiful Calendar
       ============================================ */

    /* Calendar Modal */
    [data-bs-theme="dark"] .calendar-modal {
        background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
    }

    [data-bs-theme="dark"] .calendar-modal-body::-webkit-scrollbar-track {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .calendar-modal-body::-webkit-scrollbar-thumb {
        background: #334155;
    }

        [data-bs-theme="dark"] .calendar-modal-body::-webkit-scrollbar-thumb:hover {
            background: #475569;
        }

    [data-bs-theme="dark"] .calendar-header {
        background: linear-gradient(135deg, #1a1d29 0%, #0f1117 100%);
        border-bottom-color: rgba(255, 255, 255, 0.1) !important;
    }

    [data-bs-theme="dark"] .btn-today {
        background: linear-gradient(135deg, #1e2330 0%, #111827 100%);
        border-color: #334155;
        color: #60a5fa;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }

        [data-bs-theme="dark"] .btn-today:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            border-color: #3b82f6;
            color: white;
        }

    [data-bs-theme="dark"] .month-trigger-modern {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

        [data-bs-theme="dark"] .month-trigger-modern:hover {
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }

    [data-bs-theme="dark"] .filter-toggle-btn {
        background: linear-gradient(135deg, #1e2330 0%, #111827 100%);
        border-color: #334155;
        color: #94a3b8;
    }

        [data-bs-theme="dark"] .filter-toggle-btn:hover {
            border-color: #3b82f6;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(45, 212, 191, 0.2) 100%);
            color: #60a5fa;
        }

        [data-bs-theme="dark"] .filter-toggle-btn.active {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            border-color: #3b82f6;
            color: white;
        }

            [data-bs-theme="dark"] .filter-toggle-btn.active:hover {
                background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
            }

    [data-bs-theme="dark"] .filters-panel {
        background: linear-gradient(135deg, #1a1d29 0%, #0f1117 100%);
        border-bottom-color: #334155;
        box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .filter-label {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .filter-icon {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .filter-input {
        background: rgba(15, 23, 42, 0.8);
        border-color: #334155;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .filter-input:focus {
            border-color: #3b82f6;
            background: rgba(15, 23, 42, 0.95);
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
        }

    [data-bs-theme="dark"] .select-wrapper::after {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .select-wrapper:focus-within::after {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2360a5fa' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .filters-actions {
        border-top-color: #334155;
    }

    [data-bs-theme="dark"] .filter-btn-secondary {
        background: linear-gradient(135deg, #334155 0%, #475569 100%);
        color: #cbd5e1;
        border-color: #475569;
    }

        [data-bs-theme="dark"] .filter-btn-secondary:hover {
            background: linear-gradient(135deg, #475569 0%, #64748b 100%);
            border-color: #64748b;
        }

    [data-bs-theme="dark"] .text-primary {
        color: #60a5fa !important;
    }

    /* Weekdays */
    [data-bs-theme="dark"] .weekdays .weekday {
        color: #9ca3af;

        @media (max-width: 576px) {
            color: #a8b0ba;
        }
    }

    /* Day Cells */
    [data-bs-theme="dark"] .day-cell {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);
    }

    [data-bs-theme="dark"] .day-cell:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
        border-color: rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme="dark"] .day-cell.other-month {
        background: linear-gradient(135deg, #0f1117 0%, #1a1d29 100%);
        color: #6b7280;
    }

    [data-bs-theme="dark"] .day-cell.today {
        outline: 2px solid rgba(59, 130, 246, 0.4);
        box-shadow: inset 0 0 0 2px rgba(59, 130, 246, 0.4), 0 0 20px rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .day-number {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .day-cell.other-month .day-number {
        color: #6b7280;
    }

    /* Event Pills */
    [data-bs-theme="dark"] .event-pill {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
        color: #93c5fd;
        border-color: rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme="dark"] .day-cell.other-month .event-pill {
        background: linear-gradient(135deg, #1a1f2e 0%, #232938 100%);
        border-color: rgba(255, 255, 255, 0.08);
        color: #6b7280;
    }

    [data-bs-theme="dark"] .event-pill.is-danger {
        background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
        color: #fca5a5;
        border-color: rgba(239, 68, 68, 0.3);
    }

    [data-bs-theme="dark"] .event-pill.is-warning {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        color: #fcd34d;
        border-color: rgba(245, 158, 11, 0.3);
    }

    [data-bs-theme="dark"] .event-pill.is-success {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
        color: #6ee7b7;
        border-color: rgba(16, 185, 129, 0.3);
    }


    [data-bs-theme="dark"] .event-pill.is-info {
        background: #dbeafe;
        color: #2563eb;
        border-color: #bfdbfe;
    }

    [data-bs-theme="dark"] .event-placeholder {
        background: linear-gradient(90deg, #1a1d29 0%, #252b3d 50%, #1a1d29 100%);
    }

    [data-bs-theme="dark"] .more-pill {
        background: linear-gradient(135deg, #1a1f2e 0%, #232938 100%);
        color: #d1d5db;
        border-color: rgba(255, 255, 255, 0.12);
    }

    /* Day Details Modal */
    [data-bs-theme="dark"] .day-details-modal {
        background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .day-details-header {
        background: linear-gradient(135deg, #1e40af 0%, #0891b2 100%);
    }

    [data-bs-theme="dark"] .day-details-header .calendar-icon-wrapper {
        background: rgba(255, 255, 255, 0.15);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme="dark"] .day-details-body {
        background: #1a1d29;
    }

    [data-bs-theme="dark"] .day-details-body::-webkit-scrollbar-track {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .day-details-body::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
    }

    [data-bs-theme="dark"] .day-details-body::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);
    }

    /* Empty State */
    [data-bs-theme="dark"] .empty-state .empty-icon {
        color: #4b5563;
    }

    [data-bs-theme="dark"] .empty-state h6 {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .empty-state p {
        color: #6b7280;
    }

    /* Event Cards */
    [data-bs-theme="dark"] .event-card {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }

    [data-bs-theme="dark"] .event-card:hover {
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
        border-color: rgba(59, 130, 246, 0.2);
    }

    [data-bs-theme="dark"] .event-card:hover .view-link {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .event-card-indicator {
        background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
    }

    [data-bs-theme="dark"] .event-card.is-success .event-card-indicator {
        background: linear-gradient(180deg, #10b981 0%, #059669 100%);
    }

    [data-bs-theme="dark"] .event-card.is-info .event-card-indicator {
        background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
    }

    [data-bs-theme="dark"] .event-card.is-warning .event-card-indicator {
        background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
    }

    [data-bs-theme="dark"] .event-card.is-danger .event-card-indicator {
        background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
    }

    [data-bs-theme="dark"] .event-icon {
        background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
        box-shadow: 0 4px 16px rgba(79, 70, 229, 0.4);
    }

    [data-bs-theme="dark"] .event-card.is-success .event-icon {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        box-shadow: 0 4px 16px rgba(16, 185, 129, 0.4);
    }

    [data-bs-theme="dark"] .event-card.is-info .event-icon {
        background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }

    [data-bs-theme="dark"] .event-card.is-warning .event-icon {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4);
    }

    [data-bs-theme="dark"] .event-card.is-danger .event-icon {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);
    }

    [data-bs-theme="dark"] .event-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .event-badge {
        background: linear-gradient(135deg, #1a1f2e 0%, #232938 100%);
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .event-status-badge {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
        color: #6ee7b7;
    }

    [data-bs-theme="dark"] .event-status-badge.warning {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        color: #fcd34d;
    }

    [data-bs-theme="dark"] .event-status-badge.danger {
        background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
        color: #fca5a5;
    }

    [data-bs-theme="dark"] .event-info-row {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .event-info-row i {
        color: #6b7280;
    }

    [data-bs-theme="dark"] .event-info-label {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .event-info-value {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .event-card-footer {
        border-top-color: rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .view-link {
        color: #9ca3af;
    }

    /* Buttons */
    [data-bs-theme="dark"] .btn-outline-primary {
        color: #60a5fa;
        border-color: rgba(59, 130, 246, 0.3);
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
    }

    [data-bs-theme="dark"] .btn-outline-primary:hover {
        color: #fff;
        background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
        border-color: #3b82f6;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

    /* Close button */
    [data-bs-theme="dark"] .btn-white {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border: 1px solid rgba(255, 255, 255, 0.12);
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .btn-white:hover {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.2);
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .btn-white svg {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .calendar-close-btn {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%) !important;
        border-color: #334155;

        &:hover {
            background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%) !important;
            border-color: #475569;
        }
    }


</style>
